import style from "./style.module.css"

interface ITutorialButtonProps
{
   handleClick: () => void;
}

export const ShowTutorialButton: React.FC<ITutorialButtonProps> = ({handleClick}) =>
{
  return(
    <div className={style.container} onClick={handleClick}>
        ?
    </div>
  )
}